module.exports = __webpack_public_path__ + "assets/img/chart_date_head_icon.da06c5e5.svg";